import { useTranslation } from "react-i18next";

const values = [
  { icon: "ri-open-source-line", key: "opensource", color: "#4ade80" },
  { icon: "ri-shield-keyhole-line", key: "privacy", color: "#34d399" },
  { icon: "ri-speed-line", key: "performance", color: "#6ee7b7" },
  { icon: "ri-global-line", key: "community", color: "#a7f3d0" },
  { icon: "ri-tools-line", key: "developer", color: "#4ade80" },
  { icon: "ri-building-line", key: "enterprise", color: "#34d399" },
];

export default function AboutValues() {
  const { t } = useTranslation();
  return (
    <section className="py-20 border-t" style={{ borderColor: "var(--border-color)", backgroundColor: "var(--bg-surface)" }}>
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-12">
          <span
            className="inline-block text-xs font-semibold uppercase tracking-widest mb-4 px-3 py-1 rounded-full"
            style={{ backgroundColor: "rgba(34,197,94,0.1)", color: "var(--accent)" }}
          >
            {t("about.values.label")}
          </span>
          <h2 className="text-3xl font-bold mb-3" style={{ color: "var(--text-primary)" }}>
            {t("about.values.title")}
          </h2>
          <p className="text-sm max-w-xl mx-auto" style={{ color: "var(--text-muted)" }}>
            {t("about.values.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {values.map((v) => (
            <div
              key={v.key}
              className="rounded-xl p-6 transition-all"
              style={{
                backgroundColor: "var(--bg-base)",
                border: "1px solid var(--border-color)",
              }}
            >
              <div
                className="w-10 h-10 flex items-center justify-center rounded-lg mb-4"
                style={{ backgroundColor: "rgba(34,197,94,0.1)", color: v.color }}
              >
                <i className={`${v.icon} text-lg`}></i>
              </div>
              <h3 className="text-sm font-semibold mb-2" style={{ color: "var(--text-primary)" }}>
                {t(`about.value.${v.key}.title`)}
              </h3>
              <p className="text-xs leading-relaxed" style={{ color: "var(--text-muted)" }}>
                {t(`about.value.${v.key}.desc`)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}